/** @format */

export const getGradientByDeviation = (deviationPercent: number, status?: string): string => {
  // Зеленая зона (<2%)
  if (deviationPercent < 2) {
    return 'linear-gradient(180deg, #FFD600 0%, #8BC34A 50%, #FFD600 100%)';
  }

  // Желтая зона (от 2 до 30%)
  if (deviationPercent >= 2 && deviationPercent <= 30) {
    if (status === 'over') {
      // Перерасход: Красный - Желтый - Зеленый
      return 'linear-gradient(180deg, #BE4E51 0%, #FFD600 50%, #8BC34A 100%)';
    } else {
      // Недорасход: Зеленый - Желтый - Красный
      return 'linear-gradient(180deg, #8BC34A 0%, #FFD600 50%, #BE4E51 100%)';
    }
  }

  // Красная зона (>30%)
  if (status === 'over') {
    // Перерасход: Красный - Желтый
    return 'linear-gradient(180deg, #BE4E51 0%, #FFD600 100%)';
  } else {
    // Недорасход: Желтый - Красный
    return 'linear-gradient(180deg, #FFD600 0%, #BE4E51 100%)';
  }
};

export const getLabelWithColor = (status: string) => {
  let label = '';
  let color = '';

  if (status === 'overspent') {
    label = 'Перерасход';
    color = '#BE4E51';
  } else if (status === 'underspent') {
    label = 'Недорасход';
    color = '#8BC34A';
  } else {
    label = 'Прогноз';
    color = '#8BC34A';
  }

  return {label, color};
};
